import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import attendance from "../../../containers/modules/hr/attendance";

export default function AttendanceRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="attendance"
      index
      element={
        <AccessControl
          name={"Attendance List"}
          auth={authUser}
          component={attendance}
        />
      }
    ></Route>
  );
}
